import {Tab, TabList, TabPanel, Tabs} from 'react-tabs'
import {FC} from 'react'
import {RatiosOccupancy} from '../RatiosOccupancy'
import {RatiosOccupancyBeds} from '../RatioOccupancyBeds'

const HeaderRatioOccupancyPanel: FC = () => {
  return (
    <>
      <div className='sdx_content_tab_panel'>
        <Tabs className={'sdx_sub_react_tab_panel '}>
          <TabList className={'sdx_sub_tab_panel p-0'}>
            <Tab className={'sdx_sub_tab_panel_option'}>Ocupabilidad</Tab>
            <Tab className={'sdx_sub_tab_panel_option'}>Ocupabilidad2</Tab>
          </TabList>
          <TabPanel>
            <RatiosOccupancy />
          </TabPanel>
          <TabPanel>
            <RatiosOccupancyBeds />
          </TabPanel>
        </Tabs>
      </div>
    </>
  )
}

export {HeaderRatioOccupancyPanel}
